import { createAction, props } from '@ngrx/store';

export const userProfileLanguageChanged = createAction(
  '[Translate] User Profile Language Changed',
  props<{
    language: string;
  }>(),
);

export const languageSelectedFromDropdown = createAction(
  '[Translate] Language Selected From Dropdown',
  props<{
    language: string;
  }>(),
);

export const redirectStateLanguageRestored = createAction(
  '[Translate] Redirect State Language Restored',
  props<{
    language: string;
  }>(),
);

export const currentLanguageUpdated = createAction(
  '[Translate] Current Language Updated',
  props<{
    language: string;
  }>(),
);
